export function quickSort<T>(arr: Array<T>, property: (item: T) => string | number): Array<T> {
    return arr.toSorted((a: T, b: T) => {
        const valA = property(a);
        const valB = property(b);

        if (valA < valB) return -1;
        if (valA > valB) return 1;
        return 0;
    });
}